import type {PerkIntegrationSpec, PerkIntegrationStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const CohortQrCodeConfigSchema = z.object({
  validity: z.enum(['once', 'unlimited', 'custom']),
});
export type CohortQrCodeConfig = z.infer<typeof CohortQrCodeConfigSchema>;

export const CohortQrCodeStateSchema = z.object({});
export type CohortQrCodeState = z.infer<typeof CohortQrCodeStateSchema>;

export const CohortQrCodeTokenSchema = z.object({
  code: z.string(),
  expiration: z.number(),
  used: z.boolean(),
});
export type CohortQrCodeToken = z.infer<typeof CohortQrCodeTokenSchema>;

export const CohortQrCodeAccessDataSchema = z.object({
  token: CohortQrCodeTokenSchema.optional(),
});
export type CohortQrCodeAccessData = z.infer<typeof CohortQrCodeAccessDataSchema>;

export const CohortQrCodeUsageDataSchema = z.object({
  qrCodeTokenId: z.string(),
  qrReaderId: z.string(),
  qrReaderName: z.string(),
});
export type CohortQrCodeUsageData = z.infer<typeof CohortQrCodeUsageDataSchema>;

export const ExposedCohortQrCodeUsageDataSchema = z.object({
  qrReaderId: z.string(),
  qrReaderName: z.string(),
});
export type ExposedCohortQrCodeUsageData = z.infer<typeof ExposedCohortQrCodeUsageDataSchema>;

export const CohortQrCodeExposedConfigSchema = CohortQrCodeConfigSchema;
export type CohortQrCodeExposedConfig = z.infer<typeof CohortQrCodeExposedConfigSchema>;

export type CohortQrCodePerkIntegrationStruct = PerkIntegrationStruct<
  'cohort.qr-code',
  CohortQrCodeConfig,
  CohortQrCodeExposedConfig,
  CohortQrCodeState,
  CohortQrCodeAccessData,
  null,
  CohortQrCodeUsageData,
  ExposedCohortQrCodeUsageData,
  ExposedCohortQrCodeUsageDataForExport
>;

const ExposedCohortQrCodeUsageDataForExportSchema = ExposedCohortQrCodeUsageDataSchema;
export type ExposedCohortQrCodeUsageDataForExport = z.infer<
  typeof ExposedCohortQrCodeUsageDataForExportSchema
>;

export const CohortQrCodePerkIntegrationSpec: PerkIntegrationSpec<CohortQrCodePerkIntegrationStruct> =
  {
    id: 'cohort.qr-code' as const,
    configSchema: CohortQrCodeConfigSchema,
    exposedConfigSchema: CohortQrCodeExposedConfigSchema,
    stateSchema: CohortQrCodeStateSchema,
    accessDataSchema: CohortQrCodeAccessDataSchema,
    usageInputDataSchema: z.null(),
    internalUsageDataSchema: CohortQrCodeUsageDataSchema,
    exposedUsageDataSchema: ExposedCohortQrCodeUsageDataSchema,
    exposedUsageDataForExportSchema: ExposedCohortQrCodeUsageDataForExportSchema,
    defaultMaxUsagesPerToken: null,
    requiresMerchantConnection: false,
    localizedConfig: false,
  };
